import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function FeaturesPage() {
  const features = [
    {
      icon: 'ri-camera-line',
      title: 'Photo Registration',
      description: 'Take photos of your items and add detailed descriptions. Our smart system helps you catalog everything with ease.',
      benefits: ['Multiple photo angles', 'AI-powered descriptions', 'Custom categories', 'Batch uploads']
    },
    {
      icon: 'ri-search-2-line',
      title: 'Instant Search',
      description: 'Find any item in seconds using our powerful search engine. Search by name, category, location, or even visual similarity.',
      benefits: ['Text search', 'Visual search', 'Category filters', 'Location-based search']
    },
    {
      icon: 'ri-building-line',
      title: 'Space Management',
      description: 'Organize items across multiple locations - home, office, warehouse, or storage units. Keep track of everything, everywhere.',
      benefits: ['Multiple locations', 'Room organization', 'Storage mapping', 'Location history']
    },
    {
      icon: 'ri-barcode-line',
      title: 'Smart Tagging',
      description: 'Use QR codes, barcodes, or custom tags to make item identification even faster. Perfect for businesses and large collections.',
      benefits: ['QR code generation', 'Barcode scanning', 'Custom labels', 'Bulk tagging']
    },
    {
      icon: 'ri-team-line',
      title: 'Team Collaboration',
      description: 'Share access with family members or team members. Everyone stays organized and can find what they need.',
      benefits: ['User permissions', 'Shared spaces', 'Activity tracking', 'Team notifications']
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Sync',
      description: 'All your data is securely stored in the cloud and synced across all your devices. Never lose your organization system again.',
      benefits: ['Automatic backup', 'Multi-device sync', 'Offline access', 'Data security']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Powerful Features for 
              <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent"> Smart Organization</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              QikFinder combines advanced technology with intuitive design to help you organize, find, and manage your items like never before.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            {features.map((feature, index) => (
              <div key={index} className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300">
                <div className="flex items-start space-x-6">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-white text-2xl`}></i>
                  </div>
                  
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                    <p className="text-gray-600 mb-6">{feature.description}</p>
                    
                    <div className="space-y-2">
                      {feature.benefits.map((benefit, benefitIndex) => (
                        <div key={benefitIndex} className="flex items-center space-x-2">
                          <i className="ri-check-line text-green-500"></i>
                          <span className="text-gray-700 text-sm">{benefit}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Coming Soon CTA */}
          <div className="bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">Ready to Get Organized?</h2>
            <p className="text-xl opacity-90 mb-8">QikFinder is coming soon. Be among the first to experience the future of organization.</p>
            <div className="inline-flex items-center space-x-2 bg-white/20 rounded-full px-6 py-3">
              <i className="ri-time-line"></i>
              <span>Currently in Development</span>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}